import React, { Component } from 'react';
import logout from './Logout';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";

class GenerateAndVerifyOtp extends Component {
    constructor() {
        super();
        this.state = {
            errors: {},
            resetPwdMsg: false,
            loginVal: false,
            showPwd: false,
            createac: false,
            fields: {},
            recaptchaVerified: false,
            expiryTime: null,
            otpGenerated: false,
            userEmail: "",
            otpNumber: "",
        };
    }

    componentDidMount = () => {

    }


    generateOtp = () => {
        var otpController = this;
        const userEmailId = document.getElementById('userEmail').value;

        $.ajax({
            url: "/my-jeeva-api/check-user-information",
            method: 'GET',
            data: {
                userEmailId: userEmailId.toLowerCase()
            },
            success: function (res) {
                if (res.success === true) {
                    var response = res.result;
                    if (response == null) {
                        console.log("Response is null")
                    } else {
                        console.log("OTP is sent to : ", userEmailId)
                        otpController.state.otpGenerated = true;
                        otpController.setState(otpController.state);
                    }
                } else {
                    var errors = {};
                    errors["nonRegisteredMail"] = "*Please enter your registered Email ID";
                    otpController.setState({ errors: errors });
                }
            }, error: function (xhr) {
                if (xhr.status == 401) {

                    console.log("Access Denied");
                }
            }
        })
    }

    verifyOTP = () => {

        var thisController = this;
        var userData = {
            emailId: thisController.state.userEmail,
            emailOtp: thisController.state.otpNumber,
        };
        if (thisController.state.otpNumber != "") {
            $.ajax({
                url: "/my-jeeva-api/verify-otp-for-admins",
                method: "POST",
                data: JSON.stringify(userData),
                headers: {
                    Authorization:
                        "Bearer " + localStorage.getItem("patient_app_access_token"),
                    "Content-Type": "application/json",
                },
                success: function (res) {
                    if (res.success === true) {
                        if (res.result === true) {
                            thisController.notifyOtpVerified();
                            localStorage.setItem("VerifiedEmailId", thisController.state.userEmail);
                            setTimeout(() => {
                                thisController.props.history.push({
                                    pathname: "/resetpassword",
                                });
                            }, 2000);
                            console.log("Otp verification is done");
                        } else {
                            var errors = {};
                            errors["wrongOtp"] = "*Please enter the correct OTP that has been sent to your registered email address. ";
                            thisController.setState({ errors: errors });
                        }

                    } else {
                        var errors = {};
                        errors["wrongOtp"] = "*Please enter the correct OTP that has been sent to your registered email address. ";
                        thisController.setState({ errors: errors });
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        console.log("Access Denied");
                    }
                },
            });
        }
    };


    handleOtpChange = (e) => {
        this.state.otpNumber = e.target.value;
        this.setState(this.state);
    };

    handleChangeUserEmail = (e) => {
        this.state.userEmail = e.target.value;
        this.setState(this.state);
    }


    notifyOtpVerified() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/done.svg"
                    style={{ paddingRight: "0px" }}
                    content=""
                />
                &nbsp;&nbsp;Your OTP has been successfully verified. You can now proceed to reset your password.
            </b>,
            {
                position: "top-center",
            }
        );
    }

    render() {
        return (
            <div className="wrapper">
                <ToastContainer className="Toast-at-center" />
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/responsive.css" />
                <link rel="stylesheet" href="assets/css/responsive.css" />
                <link rel="stylesheet" href="assets/css/adminlte.css" />
                <link rel="stylesheet" href="assets/css/styles.css" />
                <div className="row col-md-12 p-0 m-0">
                    <div className="col-md-5">
                        <form className="form-horizontal">
                            <div className="card-body p-0">
                                <div className="row">
                                    <div className="col-lg-12 p-0">
                                        <div className="card sign-in-right-tab" style={{ width: '100%' }}>
                                            <div className="card-body sign-in-page">
                                                <div className="col-sm-12">
                                                    <div className="logoBox">
                                                        <img src="./assets/images/jeeva-logo.svg" alt="" />
                                                        <h5 className="signinTitle" style={{ color: '#0270c0' }} >ADMINISTRATION</h5>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="card-body">
                                                        {!this.state.otpGenerated &&
                                                            <div className="col-9 p-0 mx-auto ">

                                                                <div className="input-group mb-3 mv-1" >
                                                                    <h4 style={{ fontSize: "1.1rem" }}>Please enter your registered Email Id</h4>
                                                                    <br />
                                                                    <br />
                                                                    {/* <label>Please enter your registered Email Id</label> */}
                                                                    <input type="email" className="login-form" name="userEmail" id="userEmail"
                                                                        value={this.state.userEmail}
                                                                        onChange={this.handleChangeUserEmail} placeholder="Email ID" />
                                                                </div>
                                                                <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.nonRegisteredMail}</div>
                                                                <br />
                                                                <div className="card-footera">
                                                                    <button type="button" className="btn btn-primary btn-block" onClick={this.generateOtp}>Generate OTP</button>
                                                                </div>
                                                            </div>}
                                                        {this.state.otpGenerated &&
                                                            <div className="col-9 p-0 mx-auto ">

                                                                <div className="input-group mb-3" style={{ width: '30vw' }}>
                                                                    <h4 style={{ fontSize: "1.1rem" }}>Please Enter 6 digit OTP sent to {this.state.userEmail}</h4>
                                                                    <br />
                                                                    <br />
                                                                    <input type="number" className="login-form" name="otp" id="otp"
                                                                        value={this.state.otpNumber}
                                                                        onChange={this.handleOtpChange}
                                                                        placeholder="OTP" />
                                                                </div>
                                                                <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.wrongOtp}</div>
                                                                <br />
                                                                <div className="card-footera">
                                                                    <button type="button" className="btn btn-primary btn-block" onClick={this.verifyOTP}>Verify OTP</button>
                                                                </div>
                                                            </div>}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-7 sign-in-form-bg" />
                </div>
            </div>
        );
    }

}

export default GenerateAndVerifyOtp;


// WEBPACK FOOTER //
// src/my-jeeva/login/GenerateAndVerifyOtp.js